<template>
  <v-card>
    <v-card-title v-if="checkPassword">
      <h3 class="border-bottom">
        Mot de passe requis
      </h3>
    </v-card-title>
    <v-card-text>
      <v-form @submit.prevent="connection">
        <v-text-field
          ref="user"
          v-model="user"
          :prepend-inner-icon="IconEnum.user"
          :label="$t('field.index.user')"
          :disabled="checkPassword"
          name="user"
          class="needsclick"
          type="email"
        />
        <v-text-field
          ref="pass"
          v-model="pass"
          :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPass ? 'text' : 'password'"
          :prepend-inner-icon="IconEnum.password"
          :label="$t('field.index.password')"
          name="password"
          class="needsclick"
          @click:append="displayPass"
        />
        <input
          type="submit"
          style="display: none"
        >
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn
        :id="checkPassword ? 'btn-valid-pass' : 'btn-connection'"
        color="success"
        class="bloc"
        @click="connection"
      >
        {{ checkPassword ? $t('button.dw_validation') : $t('button.dw_connection') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { IconEnum } from '@/modules/Enums'
import { $closeKeyboard } from '@/modules/Utils'

export default {
  name: 'UserConnection',

  props: {
    login: { type: String, default: '' },
    checkPassword: { type: Boolean, default: false }
  },

  data () {
    return {
      IconEnum,
      user: this.login,
      pass: '',
      showPass: false
    }
  },

  methods: {
    displayPass () {
      if (!this.showPass) {
        this.showPass = true
        setTimeout(() => { this.showPass = false }, 3000)
      }
    },
    connection () {
      if (this.user === '') {
        this.$nextTick(() => {
          this.$refs.user.focus()
        })
      } else if (this.pass === '') {
        this.$nextTick(() => {
          this.$refs.pass.focus()
        })
      } else {
        $closeKeyboard(this.$nextTick)

        this.$emit('valid', this.user, this.pass)
      }
    }
  }
}
</script>
